export const shakeAndBangSets = [
  {
    "name": "Alfa",
    "value": [12, 7, 22, 3, 15, 30, 5, 24, 9, 18],
    "direction": 1
  },
  {
    "name": "Bravo",
    "value": [1, 14, 31, 4, 25, 11, 33, 16, 29, 6],
    "direction": -1
  },
  {
    "name": "Charlie",
    "value": [10, 19, 2, 35, 8, 27, 13, 34, 20, 23],
    "direction": 1
  },
  {
    "name": "Delta",
    "value": [17, 28, 15, 21, 3, 12, 4, 30, 6, 18],
    "direction": -1
  },
  {
    "name": "Echo",
    "value": [25, 1, 34, 11, 27, 9, 4, 35, 21, 8],
    "direction": 1
  },
  {
    "name": "Foxtrot",
    "value": [5, 13, 23, 10, 19, 7, 32, 17, 28, 15],
    "direction": -1
  },
  {
    "name": "Golf",
    "value": [2, 30, 12, 8, 34, 6, 26, 9, 1, 33],
    "direction": 1
  },
  {
    "name": "Hotel",
    "value": [18, 24, 22, 3, 31, 14, 5, 30, 12, 27],
    "direction": -1
  },
  {
    "name": "India",
    "value": [4, 15, 26, 11, 20, 10, 29, 7, 3, 21],
    "direction": 1
  },
  {
    "name": "Juliett",
    "value": [16, 1, 23, 32, 13, 28, 8, 35, 5, 19],
    "direction": -1
  },
  {
    "name": "Kilo",
    "value": [9, 30, 21, 14, 35, 2, 18, 5, 26, 10],
    "direction": 1
  },
  {
    "name": "Lima",
    "value": [11, 27, 4, 23, 7, 15, 30, 19, 1, 32],
    "direction": -1
  },
  {
    "name": "Mike",
    "value": [12, 21, 4, 33, 18, 10, 14, 29, 2, 25],
    "direction": 1
  },
  {
    "name": "November",
    "value": [5, 26, 22, 17, 1, 30, 13, 19, 3, 20],
    "direction": -1
  },
  {
    "name": "Oscar",
    "value": [30, 8, 21, 11, 35, 16, 2, 24, 4, 29],
    "direction": 1
  },
  {
    "name": "Papa",
    "value": [9, 11, 17, 14, 8, 22, 25, 5, 30, 18],
    "direction": -1
  },
  {
    "name": "Quebec",
    "value": [6, 15, 3, 27, 10, 22, 35, 11, 21, 14],
    "direction": 1
  },
  {
    "name": "Romeo",
    "value": [16, 19, 12, 5, 29, 30, 18, 7, 11, 4],
    "direction": -1
  },
  {
    "name": "Sierra",
    "value": [21, 17, 27, 10, 31, 4, 35, 1, 22, 14],
    "direction": 1
  },
  {
    "name": "Uniform",
    "value": [24, 16, 11, 7, 30, 21, 25, 9, 2, 35],
    "direction": 1
  },
  {
    "name": "Victor",
    "value": [18, 1, 32, 10, 11, 26, 22, 4, 14, 3],
    "direction": -1
  },
  {
    "name": "Whiskey",
    "value": [7, 35, 15, 21, 6, 19, 28, 12, 2, 11],
    "direction": 1
  },
  {
    "name": "X-ray",
    "value": [26, 2, 30, 14, 35, 10, 9, 8, 17, 11],
    "direction": -1
  },
  {
    "name": "Yankee",
    "value": [5, 20, 22, 31, 13, 3, 25, 32, 8, 7],
    "direction": 1
  },
  {
    "name": "Zulu",
    "value": [12, 29, 31, 10, 4, 8, 15, 35, 3, 22],
    "direction": -1
  }
]
